import React, { memo } from 'react';

import { connect, useDispatch, useSelector } from 'react-redux';

import { ConnectedEmailOwner } from 'reaxl-email';

import authDuck from '@/ducks/authDuck.js';
import currentPageNameDuck from '@/ducks/currentPageNameDuck.js';
import interestRateDuck from '@/ducks/interestRateDuck.js';
import paymentsDuck from '@/ducks/paymentsDuck.js';
import preorderDuck from '@/ducks/preorderDuck.js';
import vdpActiveEmailListingDuck from '@/ducks/vdp/vdpActiveEmailListingDuck.js';
import vdpActiveInteractionDuck from '@/ducks/vdp/vdpActiveInteractionDuck.js';
import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

import useLeadAdditionalInventory from '@/hooks/useLeadAdditionalInventory';

function VehicleDetailsEmailModalContainer({
    handleAdditionalInventoryModalClose,
    hideEmailForm,
    incentivesProps,
    listingId,
    ndsOfferBreakdownProps,
    nextStepsProps,
    ownerId,
    preorderListing,
    testDriveProps,
    userDuck,
    vhrLeadGateProps,
    ...rest
}) {
    const dispatch = useDispatch();
    const isLoggedIn = useSelector(authDuck.selectors.isLoggedIn);
    const showEmailModal = useSelector(vdpActiveInteractionDuck.selectors.getShowEmailModal);
    const showEditEmailModal = useSelector(vdpActiveInteractionDuck.selectors.getShowEditEmailModal);
    const emailCTAContext = useSelector(vdpActiveInteractionDuck.selectors.getEmailCTAContext);
    const useFallbackLead = useSelector((state) => paymentsDuck.selectors.getMyWalletInteraction(state, 'useFallbackLead'));
    const showEmailFormModal = !hideEmailForm && (useFallbackLead || showEmailModal);
    const getAdditionalInventory = useLeadAdditionalInventory(true, ownerId);

    const handleOnHide = () => {
        handleAdditionalInventoryModalClose();
        dispatch(vdpActiveEmailListingDuck.creators.setActiveResults([listingId]));
        dispatch(vdpActiveInteractionDuck.creators.setKeys({
            emailCTAContext: '',
            showEmailModal: false,
            showEditEmailModal: false,
        }));
        dispatch(paymentsDuck.creators.updateMyWalletInteractions({ useFallbackLead: false }));
    };

    const formattedFilterValues = [];

    const trimCode = preorderListing?.trim ?? null;
    if (trimCode) {
        formattedFilterValues.push(trimCode);
    }

    const preorderInfo = {
        preorder: {
            ...preorderListing,
        },
    };

    const emailOwnerProps = {
        ...rest,
        userDuck,
        interestRateDuck,
        clickType: emailCTAContext === 'vi360' ? 'vi360' : null,
        currentPageNameDuck,
        ctaProps: {
            onHide: handleOnHide,
            show: showEmailFormModal,
            context: emailCTAContext,
        },
        isLoggedIn,
        formattedFilterValues,
        preorderInfo,
        handleAdditionalInventoryModalClose,
        isEditEmailModal: showEditEmailModal,
        uiContext: showEditEmailModal ? 'edit' : 'cta',
        nextStepsProps: {
            ...nextStepsProps,
            getAdditionalInventory,
        },
        ...(emailCTAContext === 'incentives' && { ...incentivesProps }),
        ...(emailCTAContext === 'vehicleHistoryReport' && { ...vhrLeadGateProps }),
        ...(emailCTAContext === 'testDrive' && { ...testDriveProps }),
        ...([
            'calculatorOfferSummary',
            'calculatorDealSubmitted',
            'calculatorLeaseError',
        ].includes(emailCTAContext) && { ...ndsOfferBreakdownProps }),
    };

    return showEmailFormModal && (
        <ConnectedEmailOwner
            {...emailOwnerProps}
        />
    );
}

const mapStateToProps = (state) => {
    const preorder = preorderDuck.selectors.getDuckState(state);
    const { activeResults = [] } = vdpActiveEmailListingDuck.selectors.getDuckState(state);
    const preorderListing = activeResults.length > 0 ? preorder[activeResults[0]] : {};
    const { id, owner = {} } = vdpResultsDuck.selectors.getVdpActiveInventory(state) || {};
    const { hideEmailForm, id: ownerId } = owner;

    return {
        hideEmailForm,
        preorderListing,
        listingId: id,
        ownerId,
    };
};

export default connect(mapStateToProps)(memo(VehicleDetailsEmailModalContainer));
